module.exports = __webpack_public_path__ + "media/icons/calendar-709f9a25.svg";